const stripeText = document.getElementById('stripeText');
const navBtn = document.getElementById('handleNav');
const filterBtn = document.getElementById('handleFilter');
const filterCloseBtn = document.getElementById('closeFilter');
const nav = document.getElementById('navbarMobile');
const filters = document.getElementById('filterNav');
const navBg = document.getElementById('navbarMobile__bg');
const filterBg = document.getElementById('shop__bg');
const navLinks = document.querySelectorAll('nav-item');
const submenuToggles = document.querySelectorAll('.nav__submenuToggle');
let currentIndex = 0;

setInterval(() => {
	stripeText.style.opacity = 0;

	setTimeout(() => {
		currentIndex = (currentIndex + 1) % stripeTexts.length;
		stripeText.innerHTML = stripeTexts[currentIndex];
		stripeText.style.opacity = 1;
	}, 500);
}, 3000);

const handleNav = () => {
	const isOpening = !nav.classList.contains('isActive');

	navBtn.classList.toggle('is-active');
	nav.classList.toggle('isActive');
	navBg.classList.toggle('isActive');
	document.body.classList.toggle('overflow-h');
	navBtn.setAttribute('aria-expanded', String(isOpening));
	navBtn.setAttribute('aria-label', isOpening ? 'Zamknij menu' : 'Otwórz menu');
	navLinks.forEach((item) => {
		item.addEventListener('click', () => {
			navBtn.classList.toggle('is-active');
			nav.classList.toggle('isActive');
			navBg.classList.toggle('isActive');
			document.body.classList.toggle('overflow-h');
		});
	});
};

const setSubmenuState = (toggle, isOpen) => {
	const submenuId = toggle.getAttribute('aria-controls');
	const submenu = document.getElementById(submenuId);
	const menuItem = toggle.closest('.menu-item-has-children');

	if (!submenu || !menuItem) {
		return;
	}

	toggle.setAttribute('aria-expanded', String(isOpen));
	submenu.hidden = !isOpen;
	menuItem.classList.toggle('is-open', isOpen);
};

submenuToggles.forEach((toggle) => {
	toggle.addEventListener('click', () => {
		const menuItem = toggle.closest('.menu-item-has-children');
		const isOpen = toggle.getAttribute('aria-expanded') === 'true';

		if (menuItem && menuItem.parentElement) {
			Array.from(menuItem.parentElement.children).forEach((sibling) => {
				if (sibling === menuItem) {
					return;
				}

				const siblingToggle = sibling.querySelector(
					':scope > .nav__itemRow > .nav__submenuToggle'
				);

				if (siblingToggle) {
					setSubmenuState(siblingToggle, false);
				}
			});
		}

		setSubmenuState(toggle, !isOpen);
	});
});

document
	.querySelectorAll(
		'.navbarMobile__nav .current-menu-ancestor > .nav__itemRow > .nav__submenuToggle'
	)
	.forEach((toggle) => setSubmenuState(toggle, true));

const handleFilter = () => {
	const isOpening = !filters.classList.contains('isActive');

	filterBtn.classList.toggle('is-active', isOpening);
	filters.classList.toggle('isActive', isOpening);
	filterBg.classList.toggle('isActive', isOpening);
	filterBtn.setAttribute('aria-expanded', String(isOpening));
	document.body.classList.toggle('overflow-h', isOpening);
};

if (filterBtn && filterCloseBtn && filters && filterBg) {
	filterBtn.addEventListener('click', handleFilter);
	filterCloseBtn.addEventListener('click', handleFilter);
	filterBg.addEventListener('click', handleFilter);
	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && filters.classList.contains('isActive')) {
			handleFilter();
			filterBtn.focus();
		}
	});
}

navBg.addEventListener('click', handleNav);
navBtn.addEventListener('click', handleNav);

let splideHomeSliderLoop = document.querySelectorAll('#splide-home-slider');
if (splideHomeSliderLoop) {
	splideHomeSliderLoop.forEach((singleLoop) => {
		var splideDefaultOptions = {
			perPage: 1,
			type: 'loop',
			height: 'auto',
			autoplay: false,
			arrows: true,
			pagination: false,
			interval: 5000,
			focus: '0',
			autoWidth: false,
			omitEnd: true,

			breakpoints: {
				575.98: {
					height: false,
					autoHeight: true,
				},
				991.98: {
					focus: 'center',
				},
			},
		};
		new Splide(singleLoop, splideDefaultOptions).mount();
	});
}
let splideAdvantagesSliderLoop = document.querySelectorAll(
	'#splide-advantages-slider'
);
if (splideAdvantagesSliderLoop) {
	splideAdvantagesSliderLoop.forEach((singleLoop) => {
		var splideDefaultOptions = {
			perPage: 4,
			type: 'loop',
			height: 'auto',
			autoplay: true,
			arrows: false,
			pagination: false,
			interval: 3000,
			height: false,
			autoHeight: true,
			breakpoints: {
				575.98: {
					perPage: 1,
				},
				768: {
					perPage: 1,
				},
				992: {
					perPage: 2,
				},
				1200: {
					perPage: 2,
				},
				1400: {
					perPage: 3,
				},
				1900: {
					perPage: 4,
				},
				4000: {
					arrows: false,
					perPage: 4,
				},
			},
		};
		new Splide(singleLoop, splideDefaultOptions).mount();
	});
}
let splideBrowseCategorySliderLoop = document.querySelectorAll(
	'#splide-browsecategory-slider'
);
if (splideBrowseCategorySliderLoop) {
	splideBrowseCategorySliderLoop.forEach((singleLoop) => {
		var splideDefaultOptions = {
			perPage: 1,
			type: 'loop',
			height: 'auto',
			autoplay: true,
			arrows: true,
			pagination: false,
			interval: 3000,
			height: false,
			autoHeight: true,
			breakpoints: {
				575.98: {
					perPage: 1,
				},
				768: {
					perPage: 1,
				},
				992: {
					perPage: 2,
				},
				1200: {
					perPage: 3,
				},
				1400: {
					perPage: 4,
				},
				1900: {
					perPage: 5,
				},
				4000: {
					perPage: 6,
				},
			},
		};
		new Splide(singleLoop, splideDefaultOptions).mount();
	});
}
let splideNewsSliderLoop = document.querySelectorAll('#splide-news-slider');
if (splideNewsSliderLoop) {
	splideNewsSliderLoop.forEach((singleLoop) => {
		var splideDefaultOptions = {
			perPage: 4,
			type: 'loop',
			height: 'auto',
			autoplay: true,
			arrows: true,
			pagination: false,
			interval: 3000,
			height: false,
			autoHeight: true,
			breakpoints: {
				575.98: {
					perPage: 1,
				},
				768: {
					perPage: 1,
				},
				992: {
					perPage: 2,
				},
				1200: {
					perPage: 4,
				},
				1400: {
					perPage: 4,
				},
				1900: {
					perPage: 4,
				},
				4000: {
					perPage: 4,
				},
			},
		};
		new Splide(singleLoop, splideDefaultOptions).mount();
	});
}
jQuery(document).ready(function ($) {
	$('#load-more').on('click', function () {
		var button = $(this);
		var data = {
			action: 'loadmore',
			page: ajax_params.current_page + 1,
			cat: ajax_params.cat,
		};

		$.ajax({
			url: ajax_params.ajax_url,
			data: data,
			type: 'POST',
			beforeSend: function () {
				button.text('Ładowanie...');
			},
			success: function (response) {
				if (response) {
					$('#postContainer').append(response);
					ajax_params.current_page++;
					button.text('Wczytaj więcej');
				} else {
					button.remove();
				}
			},
		});
	});
});
document.addEventListener('DOMContentLoaded', function () {
	const buttons = document.querySelectorAll('a.jobs__accordion');

	buttons.forEach((button) => {
		button.addEventListener('click', function (e) {
			e.preventDefault();
			const targetId = this.getAttribute('data-target');
			const contentToToggle = document.getElementById(targetId);

			if (contentToToggle.classList.contains('active')) {
				contentToToggle.classList.remove('active');
			} else {
				document.querySelectorAll('.jobs__conten.active').forEach((content) => {
					content.classList.remove('active');
				});
				contentToToggle.classList.add('active');
			}
		});
	});
});
window.addEventListener('scroll', function () {
	let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
	const element = document.querySelector('.nav__bottom-desktop');
	const elementMenu = document.querySelector('.nav__bottom-mobile');
	const buttonX = document.getElementById('handleNav');
	if (currentScroll > 41) {
		if (element) {
			element.classList.add('sticky');
		}
		if(elementMenu){
			elementMenu.classList.add('sticky');
		}
		if(buttonX){
			buttonX.classList.add('sticky');
		}
	} else {
		if (element) {
			element.classList.remove('sticky');
		}
		if (elementMenu) {
			elementMenu.classList.remove('sticky');
		}
		if (buttonX) {
			buttonX.classList.remove('sticky');
		}
	}

	lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});

const contentGalleries = document.querySelectorAll('.contentgallery');

if (contentGalleries.length) {
	const contentGalleryRowClass = /^contentgallery__item--rows-\d+$/;
	const contentGalleryMaxRowSpan = 160;
	const contentGalleryFrames = new WeakMap();
	let contentGalleryResizeTimer;

	const resetContentGalleryItemRows = (item) => {
		Array.from(item.classList).forEach((className) => {
			if (contentGalleryRowClass.test(className)) {
				item.classList.remove(className);
			}
		});
	};

	const layoutContentGallery = (gallery) => {
		const items = gallery.querySelectorAll('.contentgallery__item');
		const pendingFrame = contentGalleryFrames.get(gallery);

		if (pendingFrame) {
			window.cancelAnimationFrame(pendingFrame);
		}

		gallery.classList.remove('contentgallery--masonry');
		items.forEach(resetContentGalleryItemRows);

		const frame = window.requestAnimationFrame(() => {
			const galleryStyles = window.getComputedStyle(gallery);
			const columnCount = galleryStyles.gridTemplateColumns
				.split(' ')
				.filter(Boolean).length;

			if (columnCount < 2) {
				contentGalleryFrames.delete(gallery);
				return;
			}

			const rowSize =
				parseFloat(
					galleryStyles.getPropertyValue('--contentgallery-row-size')
				) || 1;
			const rowGap = parseFloat(galleryStyles.rowGap) || 0;

			items.forEach((item) => {
				const itemHeight = item.getBoundingClientRect().height;
				const rowSpan = Math.max(
					1,
					Math.min(
						contentGalleryMaxRowSpan,
						Math.ceil((itemHeight + rowGap) / (rowSize + rowGap))
					)
				);

				item.classList.add(`contentgallery__item--rows-${rowSpan}`);
			});

			gallery.classList.add('contentgallery--masonry');
			contentGalleryFrames.delete(gallery);
		});

		contentGalleryFrames.set(gallery, frame);
	};

	const refreshContentGalleries = () => {
		contentGalleries.forEach(layoutContentGallery);
	};

	contentGalleries.forEach((gallery) => {
		gallery.querySelectorAll('img').forEach((image) => {
			if (!image.complete) {
				image.addEventListener('load', () => layoutContentGallery(gallery), {
					once: true,
				});
			}
		});
	});

	refreshContentGalleries();
	window.addEventListener('load', refreshContentGalleries);
	if (document.fonts) {
		document.fonts.ready.then(refreshContentGalleries);
	}
	window.addEventListener('resize', () => {
		window.clearTimeout(contentGalleryResizeTimer);
		contentGalleryResizeTimer = window.setTimeout(
			refreshContentGalleries,
			150
		);
	});
}
